import { render, staticRenderFns } from "./HomePageActu.vue?vue&type=template&id=d026d31c&scoped=true"
import script from "./HomePageActu.vue?vue&type=script&lang=js"
export * from "./HomePageActu.vue?vue&type=script&lang=js"
import style0 from "./HomePageActu.vue?vue&type=style&index=0&id=d026d31c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d026d31c",
  null
  
)

export default component.exports